const imp = () => import(/* webpackChunkName: "loadSprite_custom_line"*/  "../sprite/loadSprite_custom_line");
const loadMap_custom_line: { [key: string]: () => Promise<any> } = {
  "Icon-custom01-o": imp,
  "Icon-custom02-o": imp,
  "Icon-custom03-o": imp,
  "Icon-custom04-o": imp,
  "Icon-custom05-o": imp,
  "Icon-custom06-o": imp,
  "Icon-custom07-o": imp,
  "Icon-custom09-o": imp,
  "Icon-custom08-o": imp,
  "Icon-custom11-o": imp,
  "Icon-custom10-o": imp,
  "Icon-custom12-o": imp,
  "Icon-custom13-o": imp,
  "Icon-custom14-o": imp,
  "Icon-custom15-o": imp,
  "Icon-custom16-o": imp,
  "Icon-custom18-o": imp,
  "Icon-custom17-o": imp,
  "Icon-custom19-o": imp,
  "Icon-custom20-o": imp,
  "Icon-custom21-o": imp,
  "Icon-custom22-o": imp,
  "Icon-custom23-o": imp,
  "Icon-custom24-o": imp,
  "Icon-custom25-o": imp,
  "Icon-custom26-o": imp,
  "Icon-custom27-o": imp,
  "Icon-custom28-o": imp,
  "Icon-custom29-o": imp,
  "Icon-custom30-o": imp,
  "Icon-custom31-o": imp,
  "Icon-custom32-o": imp,
  "Icon-custom33-o": imp,
  "Icon-custom34-o": imp,
  "Icon-custom35-o": imp,
  "Icon-custom36-o": imp,
  "Icon-custom37-o": imp,
  "Icon-custom38-o": imp,
  "Icon-custom39-o": imp,
  "Icon-custom40-o": imp,
  "Icon-custom41-o": imp,
  "Icon-custom42-o": imp,
  "Icon-custom43-o": imp,
  "Icon-custom44-o": imp,
  "Icon-custom45-o": imp,
  "Icon-custom46-o": imp,
  "Icon-custom47-o": imp,
  "Icon-custom48-o": imp,
  "Icon-custom49-o": imp,
  "Icon-custom50-o": imp,
  "Icon-custom51-o": imp,
  "Icon-custom52-o": imp,
  "Icon-custom53-o": imp,
  "Icon-custom54-o": imp,
  "Icon-custom55-o": imp,
  "Icon-custom56-o": imp,
  "Icon-custom57-o": imp,
  "Icon-custom58-o": imp,
  "Icon-custom59-o": imp,
  "Icon-custom60-o": imp,
  "Icon-custom61-o": imp,
  "Icon-custom62-o": imp,
  "Icon-custom63-o": imp,
  "Icon-custom64-o": imp,
  "Icon-custom65": imp,
}
export default loadMap_custom_line;